import { createApp } from 'vue'
import App from '@/page/vue/2023/topic.vue'
import '@/styles/index.scss'
import initShare from '@/utils/wxShare.js'
import tongji from '@/utils/tongji.js'; //引入统计

import Qapm from '@q/qapm';
Qapm('init', {
    appKey: 'isc',
    env: import.meta.env.MODE,
    ratio: 100,
});

tongji(); //统计
initShare({
  title: 'ISC 2023全球议题征集正式开启',
  desc: '寻找1000名Speaker and Listener 启动“议题风暴”',
  imgUrl: 'https://p3.ssl.qhimg.com/t01d91d6623debd2c0c.png',
  link: window.location.href
})
const app = createApp(App)
app.mount('#app')
